<template>
    <div class="wrap-all-input-ddl">
        <div class="error-message" v-if="!isFirstSave">{{errorInfo.msg}}</div>
        <div class="row no-gutters" v-if="isFullLbl">
            <div class="col-12">
                <div class="label-full">{{lbl.default.birthdate}}</div>
            </div>
        </div>
        <div class="row no-gutters">
            <div class="col-4 pr-1">
                <div class="label-dropdown" v-if="(errorInfo.isValid && !isFullLbl) || (isFirstSave && !isFullLbl)">
                    <span v-show="daySelect != ''">Day</span>
                </div>
                <b-dropdown class="ddl-default"
                            variant="ddl-default"
                            menu-class="ddl-menu"
                            :class="{'active' : daySelect != ''}"
                            :text="textDay"
                            :disabled="disableDay">
                    <b-dropdown-item v-for="(v,k) in dayList" :key="k" @click="selectDay(v)">
                        {{v}}
                    </b-dropdown-item>
                </b-dropdown>
            </div>
            <div class="col-4 px-1">
                <div class="label-dropdown" v-if="(errorInfo.isValid && !isFullLbl)  || (isFirstSave && !isFullLbl)">
                    <span v-show="monthSelect != ''">Month</span>
                </div>
                <b-dropdown class="ddl-default"
                            variant="ddl-default"
                            menu-class="ddl-menu"
                            :class="{'active' : monthSelect != ''}"
                            :text="textMonth"
                            :disabled="disableMonth">
                    <b-dropdown-item v-for="(v,k) in monthList" :key="k" @click="selectMonth(v)">
                        {{v}}
                    </b-dropdown-item>
                </b-dropdown>
            </div>
            <div class="col-4 pl-1">
                <div class="label-dropdown" v-if="(errorInfo.isValid && !isFullLbl) || (isFirstSave && !isFullLbl)">
                    <span v-show="yearSelect != ''">Year</span>
                </div>
                <b-dropdown class="ddl-default"
                            variant="ddl-default"
                            menu-class="ddl-menu"
                            :class="{'active' : yearSelect != ''}"
                            :text="textYear"
                            :disabled="disableYear">
                    <b-dropdown-item v-for="(v,k) in yearList" :key="k" @click="selectYear(v)">
                        {{v}}
                    </b-dropdown-item>
                </b-dropdown>
            </div>
        </div>
    </div>
</template>
<script>
import Locale from "@/helper/locale/locale.js";
import Util from "@/helper/Utility.js";
import DatetimeHelper from "@/helper/DatetimeHelper.js";

export default {
    name: "DropdownDate",
    props: {
        inputLbl: Object,
        isFirstSave: Boolean,
        errorInfo: Object,
        inputDisabled: Boolean,
        inputDisabledDay: Boolean,
        inputDisabledMonth: Boolean,
        inputDisabledYear: Boolean,
        isFullLbl: Boolean,
        setDay: String,
        setMonth: String,
        setYear: String,
    },
    data: function() {
        return {
            lbl: Locale.getLbl(),
            dayList: [],
            monthList: [],
            yearList: [],

            daySelect: '',
            monthSelect: '',
            yearSelect: '',

            textDay: 'Day',
            textMonth: 'Month',
            textYear: 'Year',

            disableDay: false,
            disableMonth: false,
            disableYear: false,
        };
    },
    created: function() {
        console.log("dropdowndate");
        this.initDropdown();
        this.textDay = this.lbl.default.day;
        this.textMonth = this.lbl.default.month;
        this.textYear = this.lbl.default.year;

    },
    mounted: function() {
        this.validate();

        if (this.inputDisabled) {
            this.disableDay = true;
            this.disableMonth = true;
            this.disableYear = true;
        } else {
            this.disableDay = this.inputDisabledDay;
            this.disableMonth = this.inputDisabledMonth;
            this.disableYear = this.inputDisabledYear;
        }

        if (!Util.isEmptyStr(this.setDay)) {
            this.selectDay(this.setDay);
        }
        if (!Util.isEmptyStr(this.setMonth)) {
            this.selectMonth(this.setMonth);
        }
        if (!Util.isEmptyStr(this.setYear)) {
            this.selectYear(this.setYear);
        }
    },
    methods: {
        initDropdown: function() {
            var i;
            for (i=1 ; i<=31 ; i++) {
                var d = i < 10 ? '0'+i : ''+i;
                this.dayList.push(d);
            }
            for (i=1 ; i<=12 ; i++) {
                var m = i < 10 ? '0'+i : ''+i;
                this.monthList.push(m);
            }

            var currentYear = new Date().getFullYear();
            for (i=0 ; i<100 ; i++) {
                var y = currentYear - i;
                this.yearList.push(y);
            }
        },

        selectDay: function(value) {
            // console.log(value);
            this.daySelect = value;
            this.textDay = value + "";
            this.valueChange();
        },
        selectMonth: function(value) {
            this.monthSelect = value;
            this.textMonth = value + "";
            this.valueChange();
        },
        selectYear: function(value) {
            this.yearSelect = value;
            this.textYear = value + "";
            this.valueChange();
        },

        //#region control input
        validate: function() {
            if (this.inputLbl.required) {
                if (Util.isEmptyStr(this.yearSelect) ||
                    Util.isEmptyStr(this.monthSelect ||
                    Util.isEmptyStr(this.daySelect)))
                {
                    this.errorInfo.isValid = false;
                    this.errorInfo.msg = this.inputLbl.required;
                    return;
                }
            }

            console.log(`${this.yearSelect}, ${this.monthSelect}, ${this.daySelect}`);
            if (!DatetimeHelper.isDatetimeValid(this.yearSelect, this.monthSelect, this.daySelect)) {
                this.errorInfo.isValid = false;
                this.errorInfo.msg = this.inputLbl.invalid;
                console.log(1);
                return;
            }
            console.log(2);

            this.errorInfo.isValid = true;
            this.errorInfo.msg = '';
        },
        valueChange: function() {
            this.validate();
            //TODO emit input
            var data = {
                day: this.daySelect,
                month: this.monthSelect,
                year: this.yearSelect,
            };
            this.$emit('onChange', data);
        },
        //#endregion control input
    },
}
</script>
<style lang="scss">
    $url-dropdown-icon: url('../../../assets/img/01-register/dropdown@3x.png');
    @import "@/style/base/common.scss";
    @import "@/style/base/inputCustom/Dropdown.scss";
</style>
<style lang="scss" scoped>
    @import "@/style/base/common.scss";

    .label-dropdown {
        font-size: 0.9rem;
        color: $font-gray;
        height: 22px;
    }

    .label-full {
        font-size: 0.9rem;
        color: $font-gray;
        height: 22px;
    }
    .wrap-all-input-ddl {
        padding-bottom: 3px;
    }
    .error-message {
        text-align: right;
        color: #f00;
        font-size: 0.9rem;
        height: 22px;
    }
</style>
